/**
 * Topics model
 */
export class Topics {
  constructor(public value: string, public menuDescription?: string) {}
}
